import { Dispatch } from 'react';
import axiosInstance, { ApiKeys, getApiUrl, logError } from 'src/utils/ApiHelper';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { IApproveOrRejectPayload, IPendingApprovalPayload } from '../interface';
import {
  setApprovalOrRejectionInProgress,
  setIDCardPendingList,
  setLoading,
  setPanCardPendingList
} from '../reducers/ApprovalsSlice';
import { EntityType } from '../constant';

export const getPendingApprovals =
  (payload: IPendingApprovalPayload) => (dispatch: Dispatch<any>) => {
    dispatch(setLoading(true));
    const url = getApiUrl(ApiKeys.GET_APPROVAL_REQUESTS, {}, { ...payload });
    axiosInstance
      .get(url)
      .then(response => {
        const list = response.data?.approvalRequestViews || [];
        const totalPendingApprovals = response.data?.totalElements || 0;
        if (payload?.entityType === EntityType.AGENT_ID) {
          dispatch(
            setIDCardPendingList({
              list,
              totalPendingApprovals,
              idCardValidAsOf: response?.headers?.date
            })
          );
          return;
        }
        dispatch(
          setPanCardPendingList({
            list,
            totalPendingApprovals
          })
        );
      })
      .catch(err => {
        logError(err, 'Getting error while fetching ID card approval list :: ' + url);
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const approveOrRejectApproval =
  (payload: IApproveOrRejectPayload, pagePayload: IPendingApprovalPayload) =>
  (dispatch: Dispatch<any>) => {
    const url = getApiUrl(ApiKeys.APPROVE_ID_CARD);
    const isPanEntity = pagePayload?.entityType === EntityType.AGENT_PAN_CARD;
    const isApproval = payload.approve;
    dispatch(setApprovalOrRejectionInProgress(true));
    axiosInstance
      .put(url, payload)
      .then(() => {
        toast(
          `${isPanEntity ? 'PAN' : 'ID'} request ${
            isApproval ? 'approved' : 'rejected'
          } successfully`,
          {
            type: 'success'
          }
        );
        dispatch(getPendingApprovals(pagePayload));
      })
      .catch(err => {
        logError(
          err,
          `Getting error while ${isApproval ? 'approving' : 'rejecting'} ID card :: ` + url
        );
        dispatch(setApprovalOrRejectionInProgress(false));
      });
  };
